<script setup lang="ts">
definePageMeta({
  title: 'pages.terms.seo.title',
  description: 'pages.terms.seo.description',
});
</script>

<template>
  <div>
    <LegalTerms />
  </div>
</template>
